var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.label,"type":{ 'is-danger': _vm.$parent.$parent.errors.has(_vm.name) },"message":_vm.$parent.$parent.errors.first(this.name)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }